<template>
	<div>
		<Header>
			<div class="leftcss"><a @click='goBack'><i class="iconfont icon---"></i></a></div>
			<div class="centercss">目录索引</div>
		</Header>

		<div class="body-main">
			<div class=tudh1><input ref="changep" class="ctuinput" :value="cpage" v-on:change='changepage'  /><span class="ctuspan">/ 118</span>
			 <span class="ctuspan" v-on:click='shouye()'>首页</span><span class="ctuspan" v-on:click='moye()'>末页</span><span class="ctuspan" v-on:click='pageup()'>上页</span><span class="ctuspan" v-on:click='pagedown()'>下页</span></div>
			<div class="mulu">
				<img id="zhutu" class="tu" :src="getPicture()" />
			</div>
		</div>
		<GoTop />
	</div>
</template>

<script>
	// @ is an alias to /src
	import Header from '@/components/Headertu.vue'
	import GoTop from '@/components/gotop.vue'
	export default {
		name: 'mulu',
		data() {
		
			return {
				cpage:1,
				 // curtu: "http://localhost/tu/mulu/1.jpg",
				showModal: false,
				tuwid:'100%',
			}
		},
		components: {
			Header,
			GoTop
		},

		methods: {
			goBack() {
				window.history.length > 1 ?
					this.$router.go(-1) :
					this.$router.push('/')
			},
			getPicture(){
          return  'https://www.daorenjia.com/tu/mulu/' + this.cpage + ".jpg"
      },
	  shouye(){
	  	 this.cpage=1;
	    
	  },
	  
			moye(){
				 this.cpage=118;
			//  this.selected=118;
			},
			pageup(){
				 if( this.cpage>1)
				 this.cpage --;
			//	  this.selected=this.cpage;
			 
			},
			pagedown(){
				 if( this.cpage<118)
				 this.cpage ++;
				// this.selected=this.cpage;
			 
			},
			changepage(){
			  this.cpage=this.$refs.changep.value;
			 
			},
			
			
		}
	}
</script>

